import { Component, Input } from "@angular/core";
import { SearchBaseRequest, SearchBaseResponse } from "../../../../modules/tcm-core.module";
import { BaseSecureSearch } from "../../security/base-secure-search/base-secure-search";

@Component({
    selector: 'tableMultiSelectrecord',
    templateUrl: './table-multi-select-record.component.html',
    standalone: false
})
export class TableMultiSelectRecordComponent {
  @Input() search: any;
  // @Input() search: BaseSecureSearch<SearchBaseRequest, SearchBaseResponse<any>>;
  constructor() {
  }
}
